var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    attrs: {
      "body-class": "p-0"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "iq-edit-list"
        }, [_c('tab-nav', {
          staticClass: "iq-edit-profile d-flex",
          attrs: {
            "pills": true
          }
        }, [_c('tab-nav-items', {
          staticClass: "col-md-4 p-0",
          attrs: {
            "active": _vm.activeTab === 'running-hour',
            "href": "#running-hour",
            "title": "RUNNING HOUR"
          },
          on: {
            "click": function click($event) {
              _vm.activeTab = 'running-hour';
            }
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-4 p-0",
          attrs: {
            "active": _vm.activeTab === 'adjustment-running-hour',
            "href": "#adjustment-running-hour",
            "title": "ADJUSTMENT RUNNING HOUR"
          },
          on: {
            "click": function click($event) {
              _vm.activeTab = 'adjustment-running-hour';
            }
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-4 p-0",
          attrs: {
            "active": _vm.activeTab === 'goh',
            "href": "#goh",
            "title": "ADJUSTMENT KICK OFF GOH"
          },
          on: {
            "click": function click($event) {
              _vm.activeTab = 'goh';
            }
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _vm.activeTab === 'running-hour' ? [_c('MainPageRunningHourNew', {
    attrs: {
      "filters": _vm.filtersRh
    }
  })] : _vm._e(), _vm.activeTab === 'adjustment-running-hour' ? [_c('AdjustmentRunningHourNew', {
    attrs: {
      "filters": _vm.filtersArh
    }
  })] : _vm._e(), _vm.activeTab === 'goh' ? [_c('MainPageGOH', {
    attrs: {
      "filters": _vm.filtersGoh
    }
  })] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }